export const COMPONENT_SELECTOR = 'core-component-';

export function getComponentSelectorId(id: string) {
  return `${COMPONENT_SELECTOR}${id}`;
}
